function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const between = ({
  min,
  max,
  num,
}: {
  min: number;
  max: number;
  num: number;
}) => {
  return Math.max(Math.min(num, max), min);
};

export { getRandomInt, between };
